import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-tools-menu',
    templateUrl: './tools-menu.component.html',
    styleUrls: ['./tools-menu.component.css'],
})
export class ToolsMenuComponent {
    /**
     * The name of the tools webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
